import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {getAssetsByUser} from "../../../../api/asset/AssetService";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import UserAccountAssetList from "./UserAccountAssetList";

const PAGE_SIZE = 15;

function UserAccountAsset({show, userAccount, embedded = false}) {
    const navigate = useNavigate();
    const [newData, setNewData] = useState(null);
    const [page, setPage] = useState(0);

    useEffect(() => {
        setPage(0);
        setNewData(null);
    }, [show, userAccount?.id]);

    useEffect(() => {
        if (!userAccount?.id) {
            return;
        }

        const pageable = {
            currentPage: page,
            page,
            size: PAGE_SIZE,
            sort: "createdAt",
            desc: true,
            totalPages: 0,
        };

        getAssetsByUser(show, userAccount, pageable).then((response) => {
            if (response?.data) {
                setNewData(response.data);
            }
        });
    }, [show, userAccount?.id, page]);

    const handleRowClick = (row) => {
        const rowId = row?.id;
        if (rowId == null) {
            return;
        }
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "자산 상세"),
            url: `/asset/${rowId}`,
        });
    };

    const handlePageChange = (pageable) => {
        setPage(pageable.pageNumber);
    };

    return (
        <UserAccountAssetList
            className={embedded ? "user-account-asset-list--embedded" : "user-account-asset-list--page"}
            newData={newData}
            onPageChange={handlePageChange}
            onRowClick={handleRowClick}
        />
    );
}

export default UserAccountAsset;
